import { Resources, ResourcesAdapter } from '@interfaces/FW/Resources';
import { moveArrayItem } from '@shared/utils/array/reorderArray';

export const postResourcesWalletAdapter = (data: ResourcesAdapter[]): Resources[] => {
	const mapped = data.map((item) => {
		return {
			walletGUID: item.Счет,
			walletName: item.СчетНаименование,
			walletState: item.СчетСостояние,
			accountView: item.СчетВид,
			nomenclature: item.Номенклатура,
			nomenclatureName: item.НоменклатураНаименование,
			unit: item.ЕдиницаИзмерения,
			fuel: item.Топливо,
			balance: item.Остаток,
			currentOverdraft: item.ТекущийОвердрафт,
			walletOverdraft: item.СчетОвердрафт,
			currency: item.Валюта,
			nomenclatureColor: item.НоменклатураЦвет,
			card: item.Карта,
			cardLink: item.КартаСсылка,
			isIndividualBalance: item.ИндивидуальныйБаланс,
		};
	});

	/**
	 * Sort array and return UAH first (if exists).
	 */
	const uahIndex = mapped.findIndex(({ currency }) => currency === 'UAH');
	if (uahIndex !== -1) {
		return moveArrayItem(mapped, uahIndex, 0);
	}

	return mapped;
};
